import React, { useContext } from 'react';
import ResultTable from '../pages/result/ResultTable';
import { YellowWarningIcon } from 'assests/GmsIcons';
import StatusIndicator from './StatusIndicator';
import { ABContext } from '../contexts/ABContext';
import { finishABTest } from '../services/ABServices';
import { toast } from 'react-toastify';

type ABPromoteModalProps = {
    onCancel: () => void
}

const ABPromoteModal = ({ onCancel }: ABPromoteModalProps) => {
    const abContext = useContext(ABContext);
    const { testData, selectedModelId, setTestData } = abContext
    const handlePromoteModel = async () => {
        try {
            const res = await finishABTest(testData?.id, selectedModelId)
            if (res?.done) {
                setTestData(res?.data)
                toast.success(res?.message ?? "Test stopped successfully")
                onCancel()
            }
            else {
                res && res?.message ? toast.info(res?.message) : toast.info("Could'nt stop the test and model promotion failed!")
            }
        } catch (error) {
            console.log("EROR", error)

            toast.info("Could'nt stop the test and model Promotion failed!")
        }
        // try {
        //     const res = await promoteModel(testData?.id, selectedModelId)
        //     if (res?.done) {
        //         onCancel()
        //         toast.success("Model Promotion Successful")
        //     }
        //     else toast.info(res?.message)
        // } catch (error) {
        //     toast.info("Model Promotion Failed")
        // }
    }

    return (
        <div className={` tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50`}>
            <div className="tw-w-[65%] tw-h-auto tw-bg-white tw-rounded tw-shadow tw-border tw-border-[#c9cccf]">
                <div className=" tw-h-[70px] tw-bg-[#f4f5f7] tw-rounded-tl tw-rounded-tr tw-border tw-border-[#c9cccf]">
                    <div className="tw-items-center tw-place-content-center tw-text-[#172b4d] tw-text-base  tw-leading-tight tw-mt-3 tw-flex ">
                        <div className='tw-m-2'>
                            <YellowWarningIcon />

                        </div>
                        <p className=' tw-font-medium'>
                            Stop A/B test and Promote model
                        </p>
                    </div>
                </div>
                <div className="tw-mt-6 tw-bg-white tw-rounded-md tw-border-[#dadbdd] tw-p-2">
                    <div className='tw-flex tw-items-center tw-justify-between'>
                        <StatusIndicator message={testData?.test_recommendation} />
                        <div className='tw-flex tw-items-center tw-gap-1'>
                            <label className='tw-text-sm tw-text-[#6B778C] tw-font-semibold'>{'MLP'}:
                                <span className='tw-text-sm tw-font-semibold tw-text-[#091E42] tw-ms-1'>{`${testData?.win_threshold}% ${testData?.metric}`}</span>
                            </label>
                        </div>
                    </div>
                    <div className='tw-mt-4 tw-pb-4'>
                        <div className="tw-text-[#172b4d] tw-text-base tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight"
                        >Select model to promote</div>
                        <div className='tw-mt-4'>
                            <ResultTable checkBox={true} />
                        </div>
                    </div>
                </div>
                {/* {
                    !selectedModelId ? <> <ABToast msg1='Not selecting any model will result in the ‘Control model’ to run in 100% traffic.' msg2=' ' /> <p className='tw-ml-[20%] tw-mt-4'> Do you want to skip? </p> </> : null
                } */}
                <div className={`tw-px-3 tw-mt-6 tw-flex tw-gap-2 tw-justify-end tw-mb-4`}>
                    <button onClick={onCancel} className='popup-button-outline'> Cancel</button>
                    <button className="popup-button-filled"
                        onClick={handlePromoteModel}
                        disabled={!selectedModelId}
                    >Stop & Promote </button>
                    {/* {selectedModelId ?
                    <button className="tw-h-auto tw-w-auto tw-px-2 tw-py-2 tw-justify-center tw-items-center tw-gap-2.5  tw-rounded-md tw-inline-flex tw-text-white hover:tw-bg-[#3024d2] tw-bg-[#0747a6]"
                        onClick={handlePromoteModel}
                        disabled={!selectedModelId}
                    >
                        Promote
                    </button> : <button className="tw-h-auto tw-w-[8%] tw-px-2 tw-py-2 tw-justify-center tw-items-center tw-gap-2.5  tw-rounded-md tw-inline-flex tw-text-white hover:tw-bg-[#3024d2] tw-bg-[#0747a6]"
                        onClick={onCancel}
                    >
                        Skip
                    </button>} */}
                </div>
            </div>
        </div>
    );
}

export default ABPromoteModal;